import React from 'react';
import { observer } from 'mobx-react-lite';
import keno8Logo from '../../assets/images/keno/keno8-logo.png';
import keno10Logo from '../../assets/images/keno/keno10-logo.png';
import { applicationStore } from '../../store/applicationStore';

const GameLogo = observer(() => {
  const { isKeno8 } = applicationStore;
  return (
    <div className='keno-betslip-logo-wrapper'>
      <img src={isKeno8 ? keno8Logo : keno10Logo} alt='Logo' />
    </div>
  );
});
export default GameLogo;
